









import { Component, Vue, Prop } from 'vue-property-decorator'
import SensorForm from './SensorForm.vue'
import { Sensor, AddSensor } from '../store/sensor'
import { namespace } from 'vuex-class'
const sensorStore = namespace('sensor')
@Component({ components: { SensorForm } })
export default class EditSensor extends Vue {
  dialog = false
  @sensorStore.Action editSensor!: (sensor: Sensor) => Promise<Sensor>
  @sensorStore.Action loadSensors!: () => void
  @Prop() sensor!: Sensor

  async edit(sensor: AddSensor) {
    await this.editSensor({ id: this.sensor.id, ...sensor })
    await this.loadSensors()
    this.dialog = false
  }
}
